import React from 'react';
import PropTypes from 'prop-types';

// extends React.Component is required because of reference in parent
export default class FieldStatus_PopoverOption extends React.Component<any> {

    onClick = () => {
        this.props.onClick(this.props.option)
    }

    render() {
        const classes = Classes('option', {
            'highlighted': this.props.isHighlighted
        });

        const valueClass = Classes('label', 'bold', 'uppercase', 'gd-scf-{0}'.f(this.props.option.color));

        return (
            <div className={classes} onClick={this.onClick}>
                <div className={valueClass}>{this.props.option.label}</div>
            </div>
        );
    }
}
